import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Button, Alert } from 'react-bootstrap'

import Card from '../_library/Card'
import BulkInvoiceForm from './BulkInvoiceForm'
import {
  FETCH_BULK_INVOICE,
  REFRESH_BULK_INVOICE,
  SEND_BULK_INVOICE
} from '../../_common/redux/bulkInvoices/actions'
import { FETCH_EVENT } from '../../_common/redux/events/actions'

const BulkInvoiceEditPage = ({ match, history, event, currentInvoice, fetchBulkInvoice, refreshBulkInvoice, fetchEvent }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [isRefreshing, setIsRefreshing] = useState(false)

  const eventId = match.params.id
  const invoiceId = match.params.invoiceId

  useEffect(() => {

    if (eventId && invoiceId) {
      setIsLoading(true)

      // Fetch event if not loaded (needed for currency)
      const eventPromise = !event ? fetchEvent(eventId) : Promise.resolve()

      Promise.all([
        eventPromise,
        fetchBulkInvoice(eventId, invoiceId)
      ])
        .then(() => {
          setIsLoading(false)
          setError(null)
        })
        .catch(err => {
          setIsLoading(false)
          setError('Failed to load invoice for editing')
        })
    } else {
      setError('Invalid event or invoice ID')
      setIsLoading(false)
    }
  }, [eventId, invoiceId])

  const handleRefresh = async () => {
    setIsRefreshing(true)
    try {
      await refreshBulkInvoice(eventId, invoiceId)
    } catch (err) {
      console.error('Failed to refresh invoice:', err)
      setError('Failed to refresh invoice. Please try again.')
    } finally {
      setIsRefreshing(false)
    }
  }

  const handleSuccess = () => {
    history.push(`/event/${eventId}/bulk-invoices/${invoiceId}`)
  }

  const handleCancel = () => {
    history.push(`/event/${eventId}/bulk-invoices`)
  }

  if (isLoading) {
    return (
      <div className="text-center p-4">
        <div className="loading-spinner">
          <i className="fa fa-spinner fa-spin fa-2x"></i>
        </div>
        <div className="mt-2">Loading invoice for editing...</div>
      </div>
    )
  }

  if (error) {
    return (
      <Alert variant="danger">
        <h5>Error Loading Invoice</h5>
        <p>{error}</p>
      </Alert>
    )
  }

  if (!currentInvoice) {
    return (
      <Alert variant="warning">
        <h5>Invoice Not Found</h5>
        <p>The requested invoice could not be found.</p>
      </Alert>
    )
  }

  return (
    <div>
      <Card
        title={`Edit Invoice ${currentInvoice.invoice_number}`}
      >
        {/* Action buttons moved to card body for consistent alignment */}
        {currentInvoice.stripe_invoice_id && ['open', 'paid'].includes(currentInvoice.status) && (
          <div className="d-flex justify-content-end mb-3">
            <Button 
              variant="warning" 
              size="sm"
              onClick={handleRefresh}
              disabled={isRefreshing}
            >
              {isRefreshing ? (
                <><i className="fa fa-spinner fa-spin" /> Refreshing...</>
              ) : (
                <><i className="fa fa-sync" /> Refresh from Stripe</>
              )}
            </Button>
          </div>
        )}
        <BulkInvoiceForm
          event={event}
          invoice={currentInvoice}
          currentInvoice={currentInvoice}
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </Card>
    </div>
  )
}

const mapStateToProps = state => ({
  event: state.events.selected,
  currentInvoice: state.bulkInvoices.currentInvoice
})

const mapDispatchToProps = dispatch => ({
  fetchBulkInvoice: (eventId, invoiceId) => dispatch(FETCH_BULK_INVOICE(eventId, invoiceId)),
  refreshBulkInvoice: (eventId, invoiceId) => dispatch(REFRESH_BULK_INVOICE(eventId, invoiceId)),
  fetchEvent: (eventId) => dispatch(FETCH_EVENT(eventId))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BulkInvoiceEditPage))
